import React, {useEffect, useRef, useState} from "react";
import {Helmet} from "react-helmet";
import Hero from "../../components/home/Hero/Hero";
import './Home.css'
import axios from "axios";
import whiteArrowIcon from '../../assets/images/Home/whiteArrow.svg'
import ruinsImg from '../../assets/images/Home/ruins.png'
import lakeImg from '../../assets/images/Home/lake.png'
import {Link} from "react-router-dom";
import Discover from "../../components/Discover/Discover";
import OherPractices from "../../components/OtherPractices/OherPractices";

export default function Home() {

    const readyMadeLicenseArr = ['EMI License', 'Ready-made company – forex broker in Saint Vincent and the Grenadines', 'Gambling license', 'Online bookmaker license in Cyprus', 'For sale ready MT5 license – forex broker', 'Financial license', 'Forex broker license', 'Fully licensed EMI UK company', 'Crypto Exchange & Wallet License For Sale', 'For sale beer retail license', 'Ready AEMI in UK for sale', 'License for a cryptocurrency company']

    const readyMadeConpaniesArr = ['UK AEMI holding in London for sale', 'Ready-made company with licenses for crypto exchange and crypto wallet', 'Accounting', 'Management Company in Cyprus', 'Ready-made company in Cyprus with an account', 'Ready-made company in Comoros', 'Ready-made company with an account', 'Custom-made company in Mwali with bank account for sale', 'Ready-made company in Western Sahara', 'Bank Technology company for sale', 'Ready-made company in Anjouan']

    const [isExpandedLicenses, setIsExpandedLicenses] = useState(false);
    const [isExpandedCompanies, setIsExpandedCompanies] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIfMobile = () => {
            // 500px - ваш порог для мобильных устройств
            setIsMobile(window.innerWidth <= 500);

            // Сбрасываем состояния при переходе на десктоп
            if (window.innerWidth > 500) {
                setIsExpandedLicenses(false);
                setIsExpandedCompanies(false);
            }
        };

        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);

        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    // SEO is handled via react-helmet in the JSX return below


    const shouldShowAllLicenses = !isMobile || isExpandedLicenses;
    const licensesToShow = shouldShowAllLicenses
        ? readyMadeLicenseArr
        : readyMadeLicenseArr.slice(0, 5);


    const shouldShowAllCompanies = !isMobile || isExpandedCompanies;
    const companiesToShow = shouldShowAllCompanies
        ? readyMadeConpaniesArr
        : readyMadeConpaniesArr.slice(0, 5);

    const toggleExpandLicenses = () => {
        setIsExpandedLicenses(!isExpandedLicenses);
    };

    const toggleExpandCompanies = () => {
        setIsExpandedCompanies(!isExpandedCompanies);
    };

    const otherPracticesArr = [
        'Accounting services', 'Attorney at law', 'Corporate services', 'Drafting contracts', 'FinTech Services', 'Forex trading license', 'Financial license', 'Forex broker license', 'ICO consulting services', 'Investment', 'Opening an account in the payment system', 'Certificates of good standing, incumbency', 'Registration of trademarks', 'Tax consulting services', 'Valuation and business-modeling', 'Opening a cryptocurrency debit card', 'Citizenship', 'Ready-made cryptocurrency licenses for sale', 'Due diligence', 'Fintech Software Development', 'Gambling', 'International business certification', 'Investment in real estate', 'Legal Opinion', 'Opening merchant account', 'Redomicile of companies', 'Support IPO', 'Trust registration'
    ]


    const formRef = useRef(null);
    const [status, setStatus] = useState({type: "idle", msg: ""});

    const siteName = "offshoreadvisory";
    const siteUrlRaw = 'https://offshoreadvisory.pro/';
    const siteUrl = (typeof siteUrlRaw === 'string') ? siteUrlRaw.replace(/\/$/, '') : siteUrlRaw;

    const onSubmit = async (e) => {
        e.preventDefault();
        const form = formRef.current;
        if (!form) return;

        const fullName = form.full_name?.value.trim() || "";
        const email = form.subscriber_email?.value.trim() || "";
        const message = form.message?.value.trim() || "";
        const privacyChecked = form.privacy_agreed?.checked;

        // honeypot
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        delete data.company;

        if (form.company && form.company.value) {
            return;
        }

        if (!/^\S+@\S+\.\S+$/.test(email)) {
            setStatus({type: "error", msg: "Please enter a valid email."});
            return;
        }

        if (!fullName) {
            setStatus({type: "error", msg: "Please enter your full name."});
            return;
        }

        if (!privacyChecked) {
            setStatus({
                type: "error",
                msg: "Please agree to the Privacy Policy.",
            });
            return;
        }

        setStatus({type: "loading", msg: "Sending your request…"});

        try {
            const response = await axios.post('https://assembly.tehnik.tech/api/send_form/from', {
                project: 'offshoreadvisory',
                subject: '/',
                data: data // все данные формы
            }, {

                headers: {
                    'Content-Type': 'application/json',

                }
            });

            form.reset();
            setStatus({
                type: "success",
                msg: "Thank you! Your request has been sent.",
            });
        } catch (err) {
            console.error(err);
            setStatus({
                type: "error",
                msg: "Couldn’t send the form right now. Please try again.",
            });
        }
    };


    return (
        <main className='main'>
            <Helmet>
                <title>Offshore Advisory Services | Formation, Licensing & Tax</title>
                <meta name="description"
                      content="Professional offshore advisory services for company formation, licensing, and tax planning to grow and expand your business globally."/>
                <meta name="keywords"
                      content="Offshore Advisory Services, International Business Consulting, Offshore Company Formation, Global Business Advisory, Corporate Structuring, Offshore Financial Services, International Tax Planning, Business Expansion, Offshore Company Registration, Ready-Made Companies, Forex License, Crypto License, Gaming License, Fintech Licensing, International Banking, Payment Solutions, Asset Protection, Trust Formation"/>

                <link rel="canonical" href={`${siteUrl}/`}/>
                <meta property="og:url" content={`${siteUrl}/`}/>
                <meta property="og:site_name" content={siteName}/>
                <meta property="og:title" content="Offshore Advisory Services | Formation, Licensing & Tax"/>
                <meta property="og:description"
                      content="Professional offshore advisory services for company formation, licensing, and tax planning to grow and expand your business globally."/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content="Offshore Advisory Services | Formation, Licensing & Tax"/>
                <meta name="twitter:description"
                      content="Professional offshore advisory services for company formation, licensing, and tax planning to grow and expand your business globally."/>
            </Helmet>
            <Hero/>
            <div className='keys-sucess-deal-container'>
                <div className="keys-content-row">
                    <div className="keys-content-item">
                        <h3>
                            Western Sahara
                        </h3>
                        <div>
                            <p>
                                Obtain gaming license in Western Sahara with only
                            </p>
                        </div>
                        <span>
                            15,000 USD
                        </span>
                    </div>
                    <div className="keys-content-item">
                        <h3>
                            Anjouan
                        </h3>
                        <div>
                            <p>
                                Obtain gaming license in A'njouan with only
                            </p>
                        </div>
                        <span>
                            19,000 USD
                        </span>
                    </div>
                    <div className="keys-content-item">
                        <h3>
                            Cyprus
                        </h3>
                        <div>
                            <p>
                                Obtain financial license in Cyprus with only
                            </p>
                        </div>
                        <span>
                            40,000 USD
                        </span>
                    </div>
                    <div className="keys-content-item">
                        <h3>
                            Mwali
                        </h3>
                        <div>
                            <p>
                                Obtain gaming license in Mwali with only
                            </p>
                        </div>
                        <span>
                            17,000 USD
                        </span>
                    </div>
                </div>

                {/* <SpecialOffer/>
                <section className='section'>
                    <HomeContent/>
                </section>

                <section className='section'>
                    <BlogList blogs={blogs} limit={5}/>
                </section>

                <BusinessList/> */}
            </div>
            <div className="offshore-zone-background">
                <div className="offshore-content">
                    <div className="ofsshore-left">
                        <h2>
                            Your offshore zone solution
                        </h2>
                        <Link to='/newsletter' className="contact-us-black-button">
                            Contact Us
                            <img src={whiteArrowIcon}/>
                        </Link>

                    </div>
                    <div className="offshore-right">
                        <div className="offshore-zone-item-descr">
                            Offshore Advisory is a premier provider of corporate, trust, fiduciary, and fund services
                            for a global clientele. We support international corporations, institutional investors,
                            high-net-worth individuals, families, and intermediaries in more than 80 countries.
                        </div>
                        <div className="offshore-zone-item-descr">
                            Alongside tailored structures, we offer access to a wide range of pre-established companies
                            in multiple jurisdictions. Our experts guide clients through the full acquisition and setup
                            process.
                        </div>
                        <div className="offshore-zone-item-descr">
                            Our clients work in IT, payments and banking, gambling, Forex, cryptocurrency, digital
                            technologies, international trade, outsourcing, logistics, and other sectors.
                        </div>
                        <div className="offshore-zone-item-descr">
                            Since its inception, Offshore Advisory has been a trusted partner for thousands of clients
                            worldwide. Our specialists know the legal nuances of each jurisdiction, ensuring solutions
                            that are compliant, efficient, and secure.
                        </div>
                    </div>
                </div>
            </div>
            <div className="loocking-information-container">
                <div className="loocking-information-upper">
                    <div className="loocking-information-item">
                        <h3 className="loocking-information-item-title">
                            80+
                        </h3>
                        <span>
                            Countries served
                        </span>
                    </div>
                    <div className="loocking-information-item">
                        <h3 className="loocking-information-item-title">
                            1000+
                        </h3>
                        <span>
                            Clients worldwide
                        </span>
                    </div>
                    <div className="loocking-information-item">
                        <h3 className="loocking-information-item-title">
                            10+
                        </h3>
                        <span>
                            Industries covered
                        </span>
                    </div>
                    <div className="loocking-information-item">
                        <h3 className="loocking-information-item-title">
                            4
                        </h3>
                        <span>
                           Core service lines
                        </span>
                    </div>
                </div>
                <div className="loocking-information-bottom">
                    <h4 className="loocking-information-title">
                        Looking for more information?
                    </h4>
                    <Link to='/newsletter' className="contact-us-white-button">
                        Learn more

                    </Link>
                </div>
            </div>
            <div className="business-for-sale-background">
                <div className="business-content">
                    <h2 className="business-main-title">
                        Businesses for sale
                    </h2>
                    <div className="business-pre-title-wrapper">
                        <p className="business-pre-title">
                            We offer a variety of licenses for sale and are ready to accommodate your business structure
                            while making a great offer tailored to your wishes.
                        </p>
                    </div>
                    <div className="business-keys-row">
                        <div className="business-keys-left">
                            <h3 className="business-key-title">
                                Ready-made licenses for sale
                            </h3>

                            <div className="business-keys-items">
                                {licensesToShow.map((el, index) => (
                                    <div className="business-key-item" key={index}>
                                        {el}
                                    </div>
                                ))}
                            </div>

                            {/* Кнопка для лицензий - показывается только на мобилках если элементов больше 5 */}
                            {isMobile && readyMadeLicenseArr.length > 5 && (
                                <button
                                    className="show-more-button"
                                    onClick={toggleExpandLicenses}
                                >
                                    {isExpandedLicenses ? 'Show Less -' : `Show More + `}
                                </button>
                            )}
                        </div>

                        <div className="business-keys-right">
                            <h3 className="business-key-title">
                                Ready-made companies for sale
                            </h3>

                            <div className="business-keys-items">
                                {companiesToShow.map((el, index) => (
                                    <div className="business-key-item" key={index}>
                                        {el}
                                    </div>
                                ))}
                            </div>

                            {/* Кнопка для компаний - показывается только на мобилках если элементов больше 5 */}
                            {isMobile && readyMadeConpaniesArr.length > 5 && (
                                <button
                                    className="show-more-button"
                                    onClick={toggleExpandCompanies}
                                >
                                    {isExpandedCompanies ? 'Show Less -' : `Show More +`}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Discover/>
            <OherPractices/>
            <div className="contact-background">
                <div className="email-block-container">
                    <h2 className="email-title">We’re thrilled to hear from you!</h2>
                    <div>
                        <form ref={formRef} onSubmit={onSubmit} noValidate>
                            <div className="input-wrapper">
                                <input
                                    name="full_name"
                                    placeholder="Full name *"
                                    required
                                />
                            </div>
                            <div className="input-wrapper">
                                <input
                                    name="subscriber_email"
                                    type="email"
                                    placeholder="Email *"
                                    required
                                />
                            </div>
                            <div className="textarea-wrapper">
                        <textarea
                            name="message"
                            placeholder="Short Brief"
                        />
                            </div>

                            {/* honeypot */}
                            <input
                                type="text"
                                name="company"
                                tabIndex={-1}
                                autoComplete="off"
                                className="cf-hp"
                                aria-hidden="true"
                            />

                            <div className="agree-privacy">
                                <div className="agree-checkbox">
                                    <input type="checkbox" name="privacy_agreed"/>
                                    <p>
                                        I agree to <Link to="">Privacy Policy</Link>
                                    </p>
                                </div>
                                <button
                                    type="submit"
                                    className="black-btn"
                                    disabled={status.type === "loading"}
                                >
                                    {status.type === "loading" ? "Sending…" : "Get Consultation"}
                                    <img src={whiteArrowIcon} alt=""/>
                                </button>
                            </div>

                            <div
                                className={`contact-status contact-status--${status.type}`}
                                aria-live="polite"
                            >
                                {status.msg}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="our-blog-container">
                <div className="our-block-upper">
                    <h2>
                        Our News & Blog
                    </h2>
                    <Link to='/blogs' className="black-btn" style={{maxWidth: '180px'}}>
                        Read more
                        <img src={whiteArrowIcon}/>
                    </Link>
                </div>


                <div className="blog-cards-row">
                    <Link to='/western-sahra-gaming-license-blog' className="blog-item-element">
                        <div>
                            <div className="blog-img-wrapper">
                                <img src={ruinsImg}/>
                            </div>
                            <h3 className="blog-item-title">
                                Why Western Sahara Is Emerging as a Strategic Jurisdiction for Gaming Licenses
                            </h3>
                            <div className="blog-item-descr-wrapper">
                                <p className="blog-item-descr">
                                    Discover why Western Sahara is becoming a new hub for iGaming licenses...
                                </p>
                            </div>
                            <div className="aditional-content">
                                <div className="blog-item-date">
                                    2025.10.01
                                </div>
                                <Link to='/western-sahra-gaming-license-blog' className="black-btn">
                                    Read more

                                </Link>
                            </div>
                        </div>
                    </Link>
                    <Link to='/anjouan-gaming-license-blog'>
                        <div className="blog-item-element">
                            <div className="blog-img-wrapper">
                                <img src={lakeImg}/>
                            </div>
                            <h3 className="blog-item-title">
                                Why the Anjouan Gaming License Is Gaining Momentum in the iGaming World
                            </h3>
                            <div className="blog-item-descr-wrapper">
                                <p className="blog-item-descr">
                                    Malta Gaming Authority is recognized worldwide for iGaming licenses...
                                </p>
                            </div>
                            <div className="aditional-content">
                                <div className="blog-item-date">
                                    2025.10.01
                                </div>
                                <Link to='/anjouan-gaming-license-blog' className="black-btn">
                                    Read more
                                </Link>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            {/* <OurServices/>
            <ContactForm/>
            <NewsletterPopup/> */}
        </main>

    )
}